import React from 'react'
import {DialogContent, Dialog, DialogTitle, Button} from '@mui/material';


export const SKUOnDeleteConfirmationPopup = (props) => {

    return (
        <Dialog
            open={props.showPopup}
            fullScreen={false}
            onClose={props.togglePopup}
            aria-label="delete-confirmation-dialog"
        >
            <DialogTitle sx={{margin: '1rem 3rem 1rem 3rem', color: '#f19100', fontSize: '2rem'}}>
                Would you like to remove your inputs from all the items selected?
            </DialogTitle>
            <Button
                variant="contained"
                sx={{margin: '3rem',
                    color:'white',
                    backgroundColor:'#f19100',
                    '&:hover': {
                        color: '#f19100',
                        backgroundColor:'white'
                      }
                }}
                onClick={() =>
                    props.handleUpdateClick(props.selectedRows, "DELETE")
                }
            >
                Yes, I want to remove selected inputs.
            </Button>
        </Dialog>
    )
}